export const meta: BlockMeta = {
  title: "Expandable Item",
}

import { Collapsible } from "@components/ui/Collapsible"
import { IconAdd } from "@components/ui/Icon"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export default defineBlock("content/expandable-item", (props) => {
  return (
    <div className="w-full mb-2">
      <Collapsible
        trigger={
          <EditableText store="ex-title" as="p" defaultValue="Example title" placeholder="Example title" plainText />
        }
        triggerClassName="!py-0 [&_p]:!type-body-m-bold justify-star text-left"
        content={
          <div className="w-full pt-2">
            <InnerBlocks allowedBlocks={["richtext"]} />
          </div>
        }
        icon={<IconAdd className="w-[2.5em] h-[2.5em]" />}
        iconClassName="transition-transform duration-200 group-data-[state=open]/box:!-rotate-45"
      />
    </div>
  )
})
